module.exports = __webpack_public_path__ + "static/1-instant_toast-86c28a912bd8ba3234b51068ca1fbbc6.png";